// 生产安全 · 10 台核心设备数据（酪蛋白产业链数字化/生产安全 下级页）
// 静态快照：数值为框架期示例，接口预留 /api/safety/devices/*
// metrics: 每台设备 2~3 项专属运行指标（min/max 用于数值微动的合理区间）

export const SAFETY_DEVICES = [
  {
    key: 'crusher', name: '原料粉碎', camera: 'Camera 01',
    desc: '牦牛奶渣预处理粉碎，出料 30 目，供后续配料与反应工序使用。',
    metrics: [
      { label: '转速', unit: 'r/min', value: 55, min: 50, max: 60, digits: 0 },
      { label: '进料速率', unit: 'kg/h', value: 320, min: 290, max: 350, digits: 0 },
      { label: '粉碎粒度', unit: '目', value: 30, min: 30, max: 30, digits: 0 },
    ],
  },
  {
    key: 'reactor', name: '反应釜', camera: 'Camera 02',
    desc: '酪蛋白酸沉反应核心设备，控温控压，保证凝乳反应稳定进行。',
    metrics: [
      { label: '釜内温度', unit: '℃', value: 42.5, min: 41, max: 44, digits: 1 },
      { label: '搅拌转速', unit: 'r/min', value: 60, min: 55, max: 65, digits: 0 },
      { label: '夹套压力', unit: 'MPa', value: 0.25, min: 0.22, max: 0.28, digits: 2 },
    ],
  },
  {
    key: 'clarifier', name: '净乳机', camera: 'Camera 03',
    desc: '离心净乳去除杂质与体细胞，保障原料乳洁净度。',
    metrics: [
      { label: '处理量', unit: 'L/h', value: 1500, min: 1400, max: 1600, digits: 0 },
      { label: '分离温度', unit: '℃', value: 40, min: 38, max: 42, digits: 0 },
      { label: '杂质去除率', unit: '%', value: 99.2, min: 98.8, max: 99.6, digits: 1 },
    ],
  },
  {
    key: 'skim', name: '脱脂机', camera: 'Camera 04',
    desc: '离心分离脱脂，控制脂肪残留，稳定酪蛋白纯度。',
    metrics: [
      { label: '脱脂率', unit: '%', value: 98.6, min: 98.2, max: 99.0, digits: 1 },
      { label: '处理量', unit: 'L/h', value: 1200, min: 1100, max: 1300, digits: 0 },
      { label: '出口温度', unit: '℃', value: 35, min: 33, max: 37, digits: 0 },
    ],
  },
  {
    key: 'sterilizer', name: '灭菌机', camera: 'Camera 05',
    desc: '巴氏/高温瞬时灭菌，杀灭致病菌，保留蛋白活性。',
    metrics: [
      { label: '灭菌温度', unit: '℃', value: 95, min: 93, max: 97, digits: 0 },
      { label: '保温时间', unit: 's', value: 30, min: 30, max: 30, digits: 0 },
      { label: '流量', unit: 'L/h', value: 1000, min: 950, max: 1050, digits: 0 },
    ],
  },
  {
    key: 'curd', name: '凝乳罐', camera: 'Camera 06',
    desc: '恒温发酵凝乳，监控 pH 与凝乳时间，形成稳定凝块。',
    metrics: [
      { label: '罐内温度', unit: '℃', value: 38, min: 36.5, max: 39.5, digits: 1 },
      { label: 'pH', unit: '', value: 4.6, min: 4.5, max: 4.7, digits: 1 },
      { label: '凝乳时间', unit: 'min', value: 45, min: 42, max: 48, digits: 0 },
    ],
  },
  {
    key: 'breaker', name: '破碎机', camera: 'Camera 07',
    desc: '凝块破碎造粒，控制颗粒均匀度，利于乳清析出。',
    metrics: [
      { label: '破碎粒度', unit: '目', value: 20, min: 20, max: 20, digits: 0 },
      { label: '转速', unit: 'r/min', value: 480, min: 450, max: 510, digits: 0 },
      { label: '负荷', unit: '%', value: 76, min: 70, max: 82, digits: 0 },
    ],
  },
  {
    key: 'dryer', name: '干燥塔', camera: 'Camera 08',
    desc: '喷雾干燥脱水成粉，进风/排风温差控制产品水分。',
    metrics: [
      { label: '进风温度', unit: '℃', value: 160, min: 155, max: 165, digits: 0 },
      { label: '排风温度', unit: '℃', value: 75, min: 72, max: 78, digits: 0 },
      { label: '出料水分', unit: '%', value: 5.2, min: 4.8, max: 5.6, digits: 1 },
    ],
  },
  {
    key: 'sifter', name: '分目机组', camera: 'Camera 09',
    desc: '多级筛分分级，按目数出料，保证粒径分布一致。',
    metrics: [
      { label: '筛分目数', unit: '目', value: 60, min: 60, max: 60, digits: 0 },
      { label: '筛分效率', unit: '%', value: 96.5, min: 95, max: 98, digits: 1 },
      { label: '处理量', unit: 'kg/h', value: 260, min: 240, max: 280, digits: 0 },
    ],
  },
  {
    key: 'packer', name: '自动包装机', camera: 'Camera 10',
    desc: '自动计量、灌装、封口、码垛，出具批次与追溯码。',
    metrics: [
      { label: '包装速度', unit: '袋/min', value: 35, min: 32, max: 38, digits: 0 },
      { label: '计量精度', unit: '±g', value: 2, min: 2, max: 2, digits: 0 },
      { label: '当日产量', unit: '袋', value: 860, min: 850, max: 880, digits: 0 },
    ],
  },
];

export const SAFETY_TIP = '点击设备图标，查看该设备的实时运行情况（监控画面 + 运行参数）';
